/* TSUKICO カスタムJS
 * テーマ本体 (theme.js) は Maestrooo のビルド成果物でテーマ更新時に上書きされる。
 * カスタム挙動はこのファイルに集約し、layout/theme.liquid から読み込む。 */
(function () {
  'use strict';

  /* 外部リンクを新しいタブで開く（rel=noopener 付与） */
  document.addEventListener('DOMContentLoaded', function () {
    var host = location.hostname;
    document.querySelectorAll('a[href^="http"]').forEach(function (a) {
      try {
        if (new URL(a.href).hostname !== host) {
          a.setAttribute('target', '_blank');
          a.setAttribute('rel', 'noopener');
        }
      } catch (e) {}
    });
  });

  /* カートナッジ（BOGO・数量割引）のワンクリック追加。
   * snippets/mask-bogo-nudge.liquid / qty-discount-nudge.liquid が出力する
   * [data-mask-add] ボタンを、この1つの委譲リスナーで処理する。
   * - カートドロワー内のボタン: テーマのセクションバンドルを取得して
   *   cart:change イベントを発火（ページリロード無しでドロワーを再描画）
   * - カートページのボタン: 追加後にリロードしてページ全体を再描画 */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mask-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '追加中…';

    var payload = {
      id: btn.dataset.maskAdd,
      quantity: parseInt(btn.dataset.maskQty, 10)
    };

    if (btn.closest('cart-drawer')) {
      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );
      payload.sections = sectionsToBundle.join(',');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function (addData) {
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cartData) {
            cartData['sections'] = addData['sections'];
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'variant:add', cart: cartData }
            }));
          });
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = original;
        });
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = '追加できませんでした。もう一度お試しください';
        });
    }
  });
  /* フッターのリンク列（sections/footer.liquid の details[data-footer-links]）。
   * HTMLは open 付きで出しているので、モバイル幅でだけ閉じる。PC幅では常に開く。 */
  var footerMq = window.matchMedia('(min-width: 750px)');
  function syncFooterLinks() {
    document.querySelectorAll('details[data-footer-links]').forEach(function (d) {
      d.open = footerMq.matches;
    });
  }
  document.addEventListener('DOMContentLoaded', syncFooterLinks);
  footerMq.addEventListener('change', syncFooterLinks);
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('details[data-footer-links] > summary');
    if (summary && footerMq.matches) e.preventDefault(); /* PC幅では閉じさせない */
  });

  /* Judge.me のレビュー一覧（.jdgm-review-widget）を最初は3件だけ表示する。
   * 一覧は Judge.me のスクリプトが後から描画するので、描画を待ってから処理する。
   * ボタンは Judge.me が再描画する範囲の外（ウィジェットの直後）に置く。 */
  var REVIEW_VISIBLE = 3;
  function collapseReviews(widget) {
    if (widget.hasAttribute('data-review-collapse')) return true;
    var items = widget.querySelectorAll('.jdgm-review-list > .jm-review-item');
    if (!items.length) return false;
    widget.setAttribute('data-review-collapse', '');
    if (items.length <= REVIEW_VISIBLE) return true;
    widget.classList.add('is-review-collapsed');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'review-more-button';
    btn.textContent = 'レビューをもっと見る';
    btn.addEventListener('click', function () {
      widget.classList.remove('is-review-collapsed');
      btn.remove();
    });
    widget.insertAdjacentElement('afterend', btn);
    return true;
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.jdgm-review-widget').forEach(function (widget) {
      if (collapseReviews(widget)) return;
      var observer = new MutationObserver(function () {
        if (collapseReviews(widget)) observer.disconnect();
      });
      observer.observe(widget, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 15000);
    });
  });
})();
